import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import { createQuoteSlice } from './slices/directQuotes.slice'
import { createEditQuoteSlice } from './slices/editQuote.slice'
import { CombinedZustandSlices } from './types'

const useQuoteStore = create<CombinedZustandSlices>()(
  devtools(
    persist(
      (...setterGetter) => ({
        ...createQuoteSlice(...setterGetter),
        ...createEditQuoteSlice(...setterGetter),
      }),
      {
        version: 1,
        name: 'signup_flow_store',
      },
    ),
  ),
)

export default useQuoteStore
